import { ref, getValues, watchValues } from '@dbk-legacy/muster/utils';
import { sortable, variable } from '@dbk-legacy/muster/helpers';
import map from 'lodash/fp/map';
import byKey from '../muster/utils/by-key';
import { PAGE } from '../constants';

export default (app, {
  positionsSortedRoute = true,
  staticRoute = true,
} = {}) => {
  app
    .require('assetsCommon.data', { '*': true })
    .require('assetsCommon.portfolioData', { '*': true })
    .require('assetsCommon.sortIsAscending', { get: true })
    .require('assetsCommon.sortByKey', { get: true })
    .require('assetsCommon.static', { '*': true })
    .require('assetsCommon.state', { '*': true })
    .require('assetsCommon.search', { '*': true })
    .path('title', ({ res }) => res.redirect('assetsCommon.data.positions[0].security.title'))
    .path('marketValue', ({ res }) => res.redirect('assetsCommon.portfolioData.marketValue.value'))
    .path('dayChange.percentage', ({ res }) =>
      res.redirect('assetsCommon.portfolioData.dayChange.percent')
    )
    .path('dayChange.value', ({ res }) =>
      res.redirect('assetsCommon.portfolioData.dayChange.value')
    )
    .path('positions.pageOffset', variable(0))
    .path('positions.pageSize', ({ res }, { get }) =>
      getValues(get(['assetsCommon.data.positions.length', 'positions.pageOffset']))
        .then(([positionsLength, pageOffset]) => {
          const pageOffsetEnd = pageOffset + PAGE.pageSize;

          if (pageOffset === 0 && positionsLength < pageOffsetEnd) {
            /* records is less than page size */
            return {
              path: 'positions.pageSize',
              value: positionsLength,
            };
          } else {
            /* records is more than page size */
            return {
              path: 'positions.pageSize',
              value: pageOffsetEnd < positionsLength ? PAGE.pageSize : positionsLength - pageOffset,
            };
          }
        })
    )
    .path('positions.length', ({ res }) =>
      res.redirect('assetsCommon.data.positions.length')
    )
    .match('positions[{integers:i}].priceHistory[{integers:j}][{keys:k}]', map(({ req, res }) =>
      res.redirect(`assetsCommon.data.positions[${req.params.i}]`
        + `.priceHistory[${req.params.j}].${req.params.k}`)
    ))
    .match('positions[{integers:i}][{keys:k1}][{keys:k2}]', map(({ req, res }) =>
      res.redirect(`assetsCommon.data.positions[${req.params.i}].${req.params.k1}.${req.params.k2}`)
    ))
    .match('positions[{integers:i}][{keys:k}]', map(({ req, res }) =>
      res.redirect(`assetsCommon.data.positions[${req.params.i}].${req.params.k}`)
    ))
    .match('positionsByPosId[{keys:k}]', (requests, { get }) =>
      watchValues(get('assetsCommon.search.filter.positionId'))
        .map(([positionId]) =>
          requests.map(({ req, res }) => {
            if (positionId == null) {
              return {
                path: req.path,
                value: null,
              };
            } else {
              return res.redirect(`assetsCommon.data.positions.pos${positionId}.${req.params.k}`);
            }
          })
        )
    )
    .match('positionsByPosId[{keys:k1}][{keys:k2}]', (requests, { get }) =>
      watchValues(get('assetsCommon.search.filter.positionId'))
        .map(([positionId]) =>
          requests.map(({ req, res }) => {
            if (positionId == null) {
              return {
                path: req.path,
                value: null,
              };
            } else {
              return res.redirect(`assetsCommon.data.positions.pos${positionId}.${req.params.k1}.${req.params.k2}`);
            }
          })
        )
    )
    .match('positionsByPosId.priceHistory[{integers:j}][{keys:k}]', (requests, { get }) =>
      watchValues(get('assetsCommon.search.filter.positionId'))
        .map(([positionId]) =>
          requests.map(({ req, res }) => {
            if (positionId == null) {
              return {
                path: req.path,
                value: null,
              };
            } else {
              return res.redirect(`assetsCommon.data.positions.pos${positionId}
                .priceHistory[${req.params.j}].${req.params.k}`);
            }
          })
        )
    )
    .match('positionsById[{keys:id}].*', byKey(
      'assetsCommon.data.positions',
      'id'
    ))
    .match('state.*', {
      get: requests => requests.map(
        ({ req, res }) => res.redirect(`assetsCommon.state.${req.params['*']}`)
      ),
      set: requests => requests.map(
        ({ req, res }) => res.redirect(`assetsCommon.state.${req.params['*']}`)
      ),
    });

  if (positionsSortedRoute) {
    app
      .match('positionsSorted[{integers:index}].*', sortable({
        fromList: 'positions',
        toList: 'positionsSorted',
        listOffset: ref('positions.pageOffset'),
        listLength: ref('positions.pageSize'),
        isAscending: ref('assetsCommon.sortIsAscending'),
        sortByKey: ref('assetsCommon.sortByKey'),
      }))
      .path('positionsSorted.length', ({ res }) =>
        res.redirect('positions.length'));
  }

  if (staticRoute) {
    app.match('static.*', requests => requests.map(
      ({ req, res }) => res.redirect(`assetsCommon.static.${req.params['*']}`))
    );
  }

  return app;
};
